module.exports = __webpack_public_path__ + "static/media/dots.c4759ea1.svg";